module.exports = __webpack_public_path__ + "static/media/strutture-gabbia-calcetto-porta-rete-noleggiocampi.7b8939bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/strutture/campi/calcetto/slider4/struttura/strutture-gabbia-calcetto-porta-rete-noleggiocampi.jpg
// module id = 646
// module chunks = 0